import { Alert, Box, Icon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { API_ROUTERS } from '../../../data';
import { useRequest, useToggle } from '../../../hooks';
import { useStoreContext } from '../../../hooks/useStore';
import { ProfileDataRow } from './ProfileDataRow';
import { EditDataBtn } from '../../Buttons/EditDataBtn';
import { FiCheck } from 'react-icons/fi';
import Countdown from 'react-countdown';

export const ProfileResetPassword = () => {
  const { t } = useTranslation();
  const { store } = useStoreContext();
  const { request } = useRequest();
  const { isShow, show, hide } = useToggle();

  const onClickEditBtn = async () => {
    const sendTo = store?.user?.email;
    await request({ method: 'post', url: API_ROUTERS.RESET_PASSWORD_SEND_EMAIL, data: { email: sendTo } });
    show();
  };

  return (
    <>
      <ProfileDataRow label={`${t('input.password.label')}`} message='••••••••••' />
      {isShow ? (
        <Countdown
          date={Date.now() + 30000}
          renderer={({ seconds }) => (
            <Alert mt={4} status='info' maxW='2xl'>
              <Icon as={FiCheck} mr={4} fontSize='xl' />
              <Box>
                <Text>{t('profile.reset.password.info.text.1')}</Text>
                <Text>{t('profile.reset.password.info.text.2', { seconds })}</Text>
              </Box>
            </Alert>
          )}
          onComplete={hide}
        />
      ) : (
        <EditDataBtn onClick={onClickEditBtn} mt={4}>
          {t('profile.change.password.btn')}
        </EditDataBtn>
      )}
    </>
  );
};
